/*
 * @Author: bbqin
 * @Date: 2022-10-18 15:31:15
 * @LastEditTime: 2023-09-14 15:22:21
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\MetaFieldSetting\setting\index.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component } from "react";

import { Tabs } from '@platform/base';
import TableSetting from "./adapter/table";
import FormSetting from "./adapter/form";
import CoreSetting from "./adapter/core";
import FromCard from "./adapter/formCard";
import MoreSetting from "./adapter/more";
const { TabPane } = Tabs;

class Setting extends Component {
    constructor(props) {
        super(props);
    }

    onTabsChange = activeKey => {
        const { store } = this.props;
        const oldActiveTabKey = store.getStore('activeTabKey');
        // TODO 是否要清除搜索数据
        if (oldActiveTabKey) {
            const viewStore = store.getStore(['cache', oldActiveTabKey, 'view']) || {};
            const fieldStore = store.getStore(['cache', oldActiveTabKey, 'field']) || {};

            store.setStore(['cache', oldActiveTabKey, 'field', 'value'], '', false);
            store.setStore(['cache', oldActiveTabKey, 'view', 'value'], '', false);

            const oldFieldData = fieldStore?.data || [];
            const oldViewData = viewStore?.data || [];

            const newFieldData = oldFieldData.map(item => {
                delete item.filtered;
                return item;
            });
            const newViewData = oldViewData.map(item => {
                delete item.filtered;
                return item;
            });

            store.setStore(['cache', oldActiveTabKey, 'field', 'data'], newFieldData, false);
            store.setStore(['cache', oldActiveTabKey, 'view', 'data'], newViewData, true);

        }

        store.setStore('activeTabKey', activeKey, true);

    }

    render() {
        const { store, id, pageScope } = this.props;
        const tabs = store.getTabs(id);
        const activeTabKey = store.getStore('activeTabKey');
        const langJson = store.getStore('langJson');

        let isFirst = true;

        return <div className="field-setting-wrapper">
            <Tabs onChange={this.onTabsChange} activeKey={activeTabKey} className="field-setting-tab">
                {tabs.map(item => {
                    const { type, name, code } = item;
                    let tp = null;
                    switch (type) {
                        case 'form':
                            tp = <TabPane className="field-setting-tab-panel" tab={isFirst ? name || langJson['setting-main-tab'] : name} key={code}><FormSetting store={store} code={code} /></TabPane>;
                            break;
                        case 'table':
                            tp = <TabPane className="field-setting-tab-panel" tab={name} key={code}><TableSetting store={store} code={code} /></TabPane>;
                            break;
                        case 'core':
                            tp = <TabPane className="field-setting-tab-panel" tab={langJson['setting-core-tab'] || name} key={code}>
                                <CoreSetting store={store} code={code} />
                            </TabPane>;
                            break;
                        case 'formCard':
                            tp = <TabPane className="field-setting-tab-panel" tab={langJson['setting-key-info-tab'] || name} key={code}>
                                <FromCard store={store} code={code} pageScope={pageScope} />
                            </TabPane>;
                            break;
                        case 'other':
                            tp = <TabPane className="field-setting-tab-panel" tab={name || langJson['setting-other-tab']} key={code}>
                                <MoreSetting store={store} code={code} />
                            </TabPane>;
                            break;
                        default:
                            tp = <TabPane className="field-setting-tab-panel" tab={name} key={code}>{
                                `not found current area code setting, please check template.${code}`
                            }</TabPane>;
                            break;
                    }
                    return tp;
                })}
            </Tabs>
        </div>;
    }
}

export default Setting;